import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "../lib/i18n.js";

/**
 * Sélecteur de langue — présent sur /login et dans le header de l'app.
 * `changeLanguage` déclenche l'écriture dans localStorage (voir `caches` dans
 * lib/i18n.ts), donc le choix persiste sans code supplémentaire ici.
 */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const current = i18n.language as SupportedLanguage;

  return (
    <label
      className={
        "flex items-center gap-1.5 text-sm text-muted-foreground " +
        (className ?? "")
      }
    >
      <Globe className="size-4" aria-hidden />
      <span className="sr-only">{t("common.language.label")}</span>
      <select
        value={SUPPORTED_LANGUAGES.includes(current) ? current : "fr"}
        onChange={(e) => {
          void i18n.changeLanguage(e.target.value);
        }}
        aria-label={t("common.language.label")}
        className="rounded-md border bg-background px-2 py-1 text-sm"
      >
        {SUPPORTED_LANGUAGES.map((lng) => (
          <option key={lng} value={lng}>
            {lng.toUpperCase()} · {t(`common.language.${lng}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
